import React, { useEffect, useState } from "react";
import { useI18n } from "../contexts/I18nContext";
import { loadGoogleAnalytics, loadMicrosoftClarity } from "../utils/scripts/Analytics";

const STORAGE_KEY = "xsiadron-cookie-consent";

function loadAnalytics() {
    loadGoogleAnalytics();
    loadMicrosoftClarity();
}

function CookieConsent() {
    const { t } = useI18n();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (!stored) {
            setVisible(true);
        } else if (stored === "accepted") {
            loadAnalytics();
        }
    }, []);

    const respond = (value) => {
        window.localStorage.setItem(STORAGE_KEY, value);
        if (value === "accepted") {
            loadAnalytics();
        }
        setVisible(false);
    };

    if (!visible) {
        return null;
    }

    return (
        <div className="cookie-consent" role="dialog" aria-live="polite">
            <p>
                {t("cookies.message")}{" "}
                <a href="/privacypolicy">{t("cookies.privacyLink")}</a>
            </p>
            <div className="cookie-consent-actions">
                <button
                    type="button"
                    className="cookie-consent-decline"
                    onClick={() => respond("declined")}
                >
                    {t("cookies.decline")}
                </button>
                <button
                    type="button"
                    className="cookie-consent-accept"
                    onClick={() => respond("accepted")}
                >
                    {t("cookies.accept")}
                </button>
            </div>
        </div>
    );
}

export default CookieConsent;
